import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import { computed, onMounted, ref } from 'vue';
import { StorageService } from '@/core/storage.service';
import SignUpDiscountPopupNameForm from '@/ui/shared/SignUpDiscountPopupNameForm.vue';
import SignUpDiscountPopupPermissionForm from '@/ui/shared/SignUpDiscountPopupPermissionForm.vue';
import { isBotOrLighthouse } from '@/core/utils/botDetection';


export default /*#__PURE__*/_defineComponent({
  __name: 'SignUpDiscountPopup',
  setup(__props) {

const showPopup = ref<boolean>(false);
const storageKey = 'signupdiscountpopup';
const currentActivatedStep = ref<number>(1);
const email = ref<string>('');
const triggered = ref<boolean>(false);

const signUpDiscountPopupImageUrl = computed<string>(() => store.getters['app/signUpDiscountPopupImageUrl']);

onMounted(() => {
    // Check if the user is a bot or Lighthouse
    if (isBotOrLighthouse()) {
        showPopup.value = false; // Do not show the popup for bots
        return;
    }

    const storageDiscountPopupItem = StorageService.getItem(storageKey);
    showPopup.value = (!storageDiscountPopupItem || (storageDiscountPopupItem && monthsBetween(new Date(), new Date(storageDiscountPopupItem)) >= 3));
});

function closePopup() {
    showPopup.value = false;
    setLocalStorage();
}

function toggle() {
    triggered.value = !triggered.value;
}

function monthsBetween(date1: Date, date2: Date) {
    const months = (date2.getFullYear() - date1.getFullYear()) * 12 + date2.getMonth() - date1.getMonth();
    return date2.getDate() < date1.getDate() ? months - 1 : months;
}

function minimize() {
    if (currentActivatedStep.value === 3) {
        closePopup();
    } else {
        toggle();
    }
}

function submitPermission(emailValue: string) {
    email.value = emailValue;
    goToNextStep();
    setLocalStorage();
}

function submitName() {
    goToNextStep();
}

function goToNextStep() {
    currentActivatedStep.value++;
}

function setLocalStorage() {
    const today: Date = new Date();
    StorageService.removeItem(storageKey);
    StorageService.setItem(storageKey, today);
}

return { __sfc: true,showPopup, storageKey, currentActivatedStep, email, triggered, signUpDiscountPopupImageUrl, closePopup, toggle, monthsBetween, minimize, submitPermission, submitName, goToNextStep, setLocalStorage, SignUpDiscountPopupNameForm, SignUpDiscountPopupPermissionForm }
}

})